import type { AxiosError } from 'axios';
import type { RaygunV2UserDetails } from 'raygun4js';
import rg4js from 'raygun4js';

import { environment } from '../environment/environment';
import { getIsOnline } from '../helpers/utils.helper';

const isLocal = environment.environment_deploy === 'local';
const basicTags = [environment.environment_deploy, `v${environment.versionNumber}`];

rg4js('options', {
  disableErrorTracking: isLocal,
});
rg4js('apiKey', environment.raygunApiKey);
rg4js('setVersion', `${environment.versionNumber}.${environment.buildNumber}`);
rg4js('enableCrashReporting', !isLocal);
rg4js('withTags', basicTags);
rg4js('filterSensitiveData', ['password', 'pass', 'new_password', 'old_password']);

export type RaygunUser = { user_id: string; role: string; organization_id: string; region?: string };

export const RaygunErrorHandlerService = () => {
  const logError = async (err: unknown, tags: string[]) => {
    const error = err as AxiosError;
    if (error.response?.status) {
      tags = [error.response.status.toString(), ...tags];
    }

    const data = { error, tags };

    const online = await getIsOnline();
    if (!isLocal && online) {
      rg4js('send', data);
    }

    if (isLocal && !(error.response && error.response.status === 401)) {
      // oxlint-disable-next-line no-console
      console.error(data);
    }
  };

  const setRaygunUser = (user: RaygunUser) => {
    const value: RaygunV2UserDetails = {
      identifier: `Role: ${user.role}, User id: ${user.user_id}, Org id: ${user.organization_id}, Region: ${user.region}`,
    };

    rg4js('setUser', value);

    if (user.region) {
      rg4js('withTags', [...basicTags, user.region]);
    }
  };

  const resetRaygunUser = () => {
    const value: RaygunV2UserDetails = { identifier: '' };
    rg4js('setUser', value);
    rg4js('withTags', basicTags);
  };

  return { logError, setRaygunUser, resetRaygunUser };
};
